
const styles={
  phoneContainer:  {
        fontSize: "1.6rem",
        fontFamily: "GoogleSans-Regular, sans-serif",
        width: "451px",
        background: "#ffffff 0% 0% no-repeat padding-box",
        border: "2px solid #e6e9ed",
        borderRadius: "8px",
        display: "flex",
        justifyContent: "flex-start",
      },

      dropDownStyle:{
        width: "451px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        alignContent: "flex-start",
        justifySelf: "flex-start",
      }

    }

    export default styles